type Props = {
  checked: boolean;
  onToggle: () => void;
  ariaLabel: string;
  /** Larger hit target + solid backdrop for the image overlay on grid cards. */
  variant?: "plain" | "overlay";
};

/**
 * Square selection checkbox shared by the catalog grid cards and table rows.
 * Stops click propagation so toggling never triggers the surrounding
 * row/card navigation.
 */
export function ProductSelectCheckbox({ checked, onToggle, ariaLabel, variant = "plain" }: Props) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={[
        "inline-flex h-[22px] w-[22px] items-center justify-center rounded-[7px] border transition-colors",
        checked
          ? "border-[color:var(--color-hero-surface)] bg-[color:var(--color-hero-surface)] text-white"
          : "border-[color:var(--border-strong)] text-transparent hover:border-[color:var(--text-muted)]",
        variant === "overlay" && !checked ? "bg-white/90 backdrop-blur" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M20 6 9 17l-5-5" />
      </svg>
    </button>
  );
}
